export const userTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: true,
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "账号组名称",
      prop: "groupName",
      placeholder: "请输入账号组名称",
      search: true,
      // editDisabled: true,
      type: "input",
    },
    {
      label: "排序",
      prop: "sort",
      type: "input",
    },
    // 工费
    {
      label: "工费",
      prop: "laborCost",
      type: "input",
    },
    // 分组类型
    {
      label: "分组类型",
      prop: "type",
      type: "select",
      dicData: [
        { label: '防水', value: 'waterProof' },
        { label: '吊顶', value: 'HANG_CEILING' },
      ],
    },
  ],
};
